export default __webpack_public_path__ + "assets/images/c4aa21d03d281a3001904df735055d26.jpeg";